import React from "react";
import { faLocationArrow, faMapMarked, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { truncate } from "../../helpers/string";
import PluginWrapper from "./PluginWrapper";
import PluginSection from "./PluginSection";
import PluginHeader from "./PluginHeader";
import PluginCloseButton from "./PluginCloseButton";
import { getIconUrl } from "../../plugins/unt/assets/iconUrls";

class SpotList extends React.Component {
  //   static propTypes = {
  //     data: PropTypes.object
  //   };

  //   componentWillReceiveProps(nextProps) {
  //   }

  //   componentDidUpdate() {
  //   }

  //   componentDidMount() {
  //   }

  truncate = (string, length = 100) => {
    if (string !== undefined && string !== null && string.length > length)
      return string.substring(0, length) + "...";
    else return string;
  };

  render() {
    const { features, onFeatureClick, onShowOnMapClick, onClose, geolocatePosition } = this.props;

    // let distanceToGeolocateInfo = null;
    // if (geolocatePosition !== null) {
    //   var from = point(selectedFeature.geometry.coordinates);
    //   var to = point([geolocatePosition.coords.longitude, geolocatePosition.coords.latitude]);
    //   var options = {units: 'kilometres'};

    //   var distanceInfo = distance(from, to, options);
    //   console.log("distanceInfo", distanceInfo);

    //   // console.log("feature coordinates", selectedFeature.geometry.coordinates);

    //   distanceToGeolocateInfo = <h6 className="f4 fw4 i lh-title mt0">
    //     Entfernung: {parseInt(distanceInfo * 1000, 10)} m
    //   </h6>
    // }

    let naviLink = "http://maps.google.com/maps?q=";
    if (navigator.userAgent.match(/(iPad|iPhone|iPod|Mac)/g)) {
      naviLink = "maps://maps.apple.com/?q=";
    }

    const listItems = features.map((feature) => {
      console.log("--- listItems", feature.properties);
      const openNaviLink = `${naviLink}${feature.geometry.coordinates[1]},${feature.geometry.coordinates[0]}`;
      let imgSrc;
      let title;
      if (feature.properties.isDeinUlm) {
        imgSrc = feature.properties.picture_url_thumb;
        title = feature.properties.title; 
      } else {
        imgSrc = getIconUrl(feature.properties.icon_url);
        title = feature.properties.name;
      }
      console.log("--- spotList", imgSrc);

      return (
        <article
          key={feature.properties.id}
          className="dt w-100 bb b--black-05 pb2 mt2 pointer"
          href="#0"
        >
          <div
            onClick={() => {
              onFeatureClick(feature);
            }}
            className="dtc hmax6 h6"
            style={{ width: "55px" }}
          >
            <img
              src={imgSrc}
              className="db mr1"
              alt="spot"
              style={{ width: "44px", height: "44px" }}
            />
          </div>
          <div
            onClick={() => {
              onFeatureClick(feature);
            }}
            className="dtc v-mid pl3"
          >
            <h1 className="f6 f5-ns fw6 lh-title black mv0">{title}</h1>
            <p className="f6 fw4 mt0 mb0 black-60">
              {this.truncate(feature.properties.description, 300)}
            </p>
          </div>
          <div className="dtc v-mid pl3" style={{ width: "33px" }}>
            <button
              onClick={() => {
                onShowOnMapClick(feature);
              }}
              className="f6 button-reset bw0 bg-white dim pointer pv1 black-20"
            >
              <FontAwesomeIcon icon={faMapMarked} />
            </button>
          </div>
          <div className="dtc tr pl3 v-mid" style={{ width: "33px" }}>
            <a
              href={openNaviLink}
              className="f6 button-reset bg-white dim pointer pv1 black-20"
            >
              <FontAwesomeIcon icon={faLocationArrow} />
            </a>
          </div>
        </article>
      );
    });

    return (
      <PluginWrapper>
        <div className="absolute bottom-0 top-0 w-100 overflow-y-auto">
          <article className="ph3">
            <PluginSection>
              <PluginHeader>Infopunkte</PluginHeader>
              {/* <h2 className="f3 mid-gray lh-title">
              An excerpt from the Form of the Book by Jan Tschichold
            </h2> */}
            </PluginSection>
            <PluginSection>{listItems}</PluginSection>
          </article>
        </div>
        <PluginCloseButton onClick={onClose} />
      </PluginWrapper>
    );
  }
}

export default SpotList;
